
import React, { useState, useEffect, useRef } from "react";
import Select from "react-select";
// import { useReactToPrint } from "react-to-print";
import { ArrowLeft, Download, FileDown, Mail, MoveLeft, Play, Printer, PrinterCheck, Search, Settings } from 'lucide-react';
import classes from "./MemeberPaySlipReport.module.css";
import RotatingLogo from '../../Assets/Promix.svg'
import BackLogo from '../../Assets/assets/back.svg'
import { MdOutlineRemoveRedEye } from "react-icons/md";
import { RiDeleteBinLine } from "react-icons/ri";
import { Spinner, Badge, Button, Modal, Form } from 'react-bootstrap';
import CurrencyInput from 'react-currency-input-field';
import axios from "axios";
import { useLocation, useNavigate } from "react-router-dom";
import Skeleton from "react-loading-skeleton";
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import Swal from "sweetalert2";
import api, { BASE_URL } from "../../Components/API/Api";
import HeaderNav from "../../Components/Dahboard Header/HeaderNav/HeaderNav";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";


const defaultData = {
  companyName: 'BROOKES COOPERATIVE SOCIETY',
  period: 'June 2026',
  payslipNo: 'PSL-202606-000124',
  member: {
    membershipNo: 'COP000124',
    name: 'ODUNLAMI KAYODE',
    department: 'Finance',
    payrollNo: 'PAY00124',
  },
  summary: {
    savings: 50000,
    loanRepayment: 35000,
    shareCapital: 10000,
    totalDeduction: 95000,
  },
  deductions: [
    { description: 'Monthly Savings Contribution', amount: 50000 },
    { description: 'Personal Loan Repayment', amount: 30000 },
    { description: 'Loan Interest', amount: 5000 },
    { description: 'Share Capital Contribution', amount: 10000 },
    { description: 'Emergency Fund', amount: 0 },
  ],
  loanSummary: {
    loanProduct: 'Personal Loan',
    originalAmount: 500000,
    outstandingBalance: 285000,
    nextInstallment: '31-Jul-2026',
  },
  savingsSummary: {
    currentBalance: 2500000,
    totalContributions: 3850000,
    lastContributionDate: '30-Jun-2026',
  },
  printedOn: '25-Jun-2026 10:30 AM',
};

function formatNaira(amount) {
  return `₦${Number(amount).toLocaleString('en-NG')}`;
}

const MemeberPaySlipReport = ({ data = defaultData } = {}) => {

    const {
    companyName,
    period,
    payslipNo,
    member,
    summary,
    deductions,
    loanSummary,
    savingsSummary,
    printedOn,
  } = data;

  // const totalDeductions = deductions.reduce((sum, item) => sum + item.amount, 0);
  const totalDeductions = 22;

  const location = useLocation();
  const receiptRef = useRef(null);
  const [savings, setSavings] = useState([]);
const [noData, setNoData] = useState(false);
const [savingsTypeLoading, setSavingsTypeLoading] = useState(false);
  const [accounts, setAccounts] = useState([]);
  const [bearer, setBearer] = useState('');
  const [savingsLoading, setSavingsLoading] = useState(false);
  const navigate = useNavigate();
  const [savingsId, setSavingsId] = useState("");
  const [selectedProductId, setSelectedProductId] = useState("");
  const [selectedCompanyId, setSelectedCompanyId] = useState("");
  const [selectedProducts, setSelectedProducts] = useState([]);
  const [reportColumns, setReportColumns] = useState([]);
  const [reportRows, setReportRows] = useState([]);
  const [reportMonth, setReportMonth] = useState("");

  const readData = async () => {
    try {
      const value = await localStorage.getItem('authToken');
     

      if (value !== null) {
        setBearer(value);
      }
    
    } catch (e) {
      alert('Failed to fetch the input from storage');
    }
  };

  useEffect(() => {
    readData();
  }, []);

  const headers = {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${bearer}`
  };


// const [summary, setSummary] = useState([]);


 const fetchReports = async () => {
  setSavingsLoading(true);
  try {
    const companyId = localStorage.getItem("company_id") || localStorage.getItem("companyId");
    
    const response = await api.get(`/v1/member_payslip_report`, {
      params: {
      company_id: companyId,
      member_id: selectedProductId,
      // month: selectedProductId,
      },
      headers: {
        'Content-Type': 'application/json'
       
      }
    });

  

    const data = response.data?.data;

    setReportColumns(data?.columns || []);
    setReportRows(data?.rows || []);
    setReportMonth(data || "");
   

    if ((data?.rows || []).length === 0) {
        Swal.fire({
            icon: "error",
            title: "No Data Found",
            text: "No data to be displayed."
        });

        setReportColumns([]);
        setReportRows([]);
        return;
    }
    

  } catch (error) {
    if (error.response && error.response.status === 401) {
      navigate('/login');
    } else {
      console.log(error);
      setAccounts([]);   // ✅ also clear here on error
      setNoData(true);
    }
  } finally {
    setSavingsLoading(false);
  }
};

  useEffect(() => {
    const fetchSavingsTypes = async () => {
      setSavingsTypeLoading(true);
      try {
        const token = localStorage.getItem("authToken");
        const res = await api.get('/v1/member/paginate', 
          { 
            // params: { name: 'payment' } 
        }
      );
        if (res.data.data.data && Array.isArray(res.data.data.data)) {
          setSavings(res.data.data.data);
        } else {
          setSavings([]);
        }
      } catch (err) {
        setSavings([]);
      } finally {
        setSavingsTypeLoading(false);
      }
    };
    fetchSavingsTypes();
  }, []);

  const memberOptions = savings.map((data) => ({
  value: data.id,
  label: data.name,
  ...data,
}));





const tableRef = useRef(null);

const printReport = () => {
  const printContents = receiptRef.current.innerHTML;

  const printWindow = window.open("", "_blank", "width=1200,height=900");

  printWindow.document.write(`
    <!DOCTYPE html>
    <html>
      <head>
        <title>Member's Pay Slip Report</title>

        <style>

          body{
              font-family: Arial, sans-serif;
              margin:20px;
              color:#000;
          }

          h1{
              text-align:center;
              margin-bottom:5px;
          }

          p{
              text-align:center;
              margin-top:0;
              margin-bottom:25px;
          }

          table{
              width:100%;
              border-collapse:collapse;
          }

          th,td{
              border:1px solid #ddd;
              padding:8px;
              font-size:12px;
              text-align:left;
          }

          th{
              background:#f3f4f6;
              color:#000;
              font-weight:bold;
          }

          tr{
              page-break-inside:avoid;
          }

          @page{
              margin:10mm;
          }

        </style>

      </head>

      <body>

      ${printContents}

      </body>

    </html>
  `);

  printWindow.document.close();

  printWindow.focus();

  setTimeout(() => {
    printWindow.print();
    printWindow.close();
  }, 500);
};

const userData = JSON.parse(localStorage.getItem('userData'));

const exportToExcel = () => {
  if (!reportRows.length) {
    Swal.fire({
      icon: "warning",
      title: "No Data",
      text: "There is no report to export.",
    });
    return;
  }

  // Table rows
  const excelData = reportRows.map((row, index) => ({
    "S/N": index + 1,
    "MEMBER NAME": row.member_name,
    "MEMBER NUMBER": row.member_number,
    "DEPARTMENT": "--",
    "TOTAL SAVINGS": Number(row.total_savings),
    "TOTAL LOAN": Number(row.total_loans),
    "TOTAL DEDUCTION": Number(row.total_deduction),
  }));

  // Add empty row
  excelData.push({});

  // Summary section
  excelData.push({
    "S/N": "SUMMARY",
    "MEMBER NAME": "",
    "MEMBER NUMBER": "",
    "DEPARTMENT": "",
    "TOTAL SAVINGS": "",
    "TOTAL LOAN": "",
    "TOTAL DEDUCTION": "",
  });

  excelData.push({
    "S/N": "Total Savings Deduction",
    "TOTAL DEDUCTION": Number(reportMonth.total_savings || 0),
  });

  excelData.push({
    "S/N": "Total Loan Deduction",
    "TOTAL DEDUCTION": Number(reportMonth.total_loans || 0),
  });

  excelData.push({
    "S/N": "Total Deductions",
    "TOTAL DEDUCTION": Number(reportMonth.total_deductions || 0),
  });

  const worksheet = XLSX.utils.json_to_sheet(excelData);

  // Auto width
  worksheet["!cols"] = [
    { wch: 8 },
    { wch: 35 },
    { wch: 20 },
    { wch: 20 },
    { wch: 18 },
    { wch: 18 },
    { wch: 20 },
  ];

  const workbook = XLSX.utils.book_new();

  XLSX.utils.book_append_sheet(
    workbook,
    worksheet,
    "Summary Deduction Report"
  );

  const excelBuffer = XLSX.write(workbook, {
    bookType: "xlsx",
    type: "array",
  });

  const file = new Blob([excelBuffer], {
    type:
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });

  saveAs(
    file,
    `Summary_Monthly_Deduction_${reportMonth?.month || ""}.xlsx`
  );
};


  return (
    <div style={{ backgroundColor: "#f9f9f9", minHeight: "100vh" }}>
      <HeaderNav />

      <div className={classes.topContainer}>
        <div className={classes.backTxt}>
          {/* <MoveLeft className={classes.iconBtn} onClick={() => navigate(-1)} /> */}
          <img src={BackLogo} alt="back" className={classes.iconBtn} onClick={() => console.log("icon3")} />
          <div className={classes.bckText}>
            <h3 className={classes.topText}>Member's Pay Slip Report </h3>
            
          </div>
          
        </div>
         <div className={classes.Group3} style={{marginTop: '32px'}}>
          <div>
            <label>Member</label>
              <div className={classes.searchableDropdown}>
              <Select
                options={memberOptions}
                value={memberOptions.find(option => option.value === selectedProductId) || null}
                onChange={(selected) => setSelectedProductId(selected?.value || "")}
                placeholder="Select Member..."
                isLoading={savingsTypeLoading}
                isSearchable
                  styles={{
                  control: (provided) => ({

                    ...provided,

                    minHeight: "35px",

                    height: "35px",

                    borderRadius: "6px",

                    borderColor: "#d1d5db",

                    fontSize: 13,

                    // zIndex: 99999,

                    boxShadow: "none",

                    "&:hover": {

                      borderColor: "#6b7280",

                    },

                  }),

                  valueContainer: (provided) => ({

                    ...provided,

                    height: "35px",

                    padding: "0 8px",

                  }),

                  input: (provided) => ({

                    ...provided,

                    margin: 0,

                    padding: 0,

                    fontSize: 13

                  }),

                  indicatorsContainer: (provided) => ({

                    ...provided,

                    height: "35px",

                  }),

                  clearIndicator: (provided) => ({

                    ...provided,

                    padding: "4px",

                  }),

                  dropdownIndicator: (provided) => ({

                    ...provided,

                    padding: "4px",

                  }),

                  menu: (provided) => ({

                    ...provided,

                    zIndex: 99999,

                    fontSize: 13

                  }),

                }}
              />
        {/* <select
  value={selectedProductId}
  onChange={(e) => {
    const productId = Number(e.target.value);

    const selectedItem = savings.find(
      (item) => item.id === productId
    );

    if (!selectedItem) return;

    setSelectedProductId(productId);
    setSelectedCompanyId(selectedItem.company_id);
    setSavingsId(selectedItem.id);

    setSelectedProducts((prev) => {
      const exists = prev.some(
        (product) => product.id === selectedItem.id
      );

      if (exists) return prev;

      return [...prev, selectedItem];
    });
  }}
>
  <option value="">Select Month</option>

  {savingsTypeLoading ? (
    <option disabled>Loading months...</option>
  ) : (
    savings.map((product) => (
      <option
        key={product.data}
        value={product.data}
      >
        {product.data}
      </option>
    ))
  )}
</select> */}

                
          </div>
          </div>
         
          <button disabled={!selectedProductId || savingsTypeLoading} className={classes.loanBtn} onClick={fetchReports}> <Play size={14} color="#fff"/> Run Report </button>
         
          </div>
      
        <div style={{ marginTop: 24 }} />
       
        <div  className={classes.tableContainer}>
         
         {/* {reportRows.length === 0 ? (
             <div
               style={{
                 textAlign: "center",
                 padding: "40px",
                 fontSize: "18px",
                 color: "#374151",
               }}
             >
               <p>No data to display</p>
             </div>
           ) : ( */}
             <>
               {/* <div className={classes.sideTools}>
                 {reportRows.length > 0 && (
                   <div className={classes.filterIcons}>
                     <Mail
                       className={classes.iconBtns}
                       onClick={() => console.log("icon1")}
                     />
                     <PrinterCheck 
                      onClick={printReport}
                      //  onClick={() => window.print()}
                       className={classes.iconBtns}
                     />
                    <FileDown 
                       className={classes.iconBtns}
                       onClick={exportToExcel}
                     />
                   </div>
                 )}
               </div>
             <div ref={receiptRef} style={{
    // padding: "40px",
    background: "#ffffff",
  }}>
          <div className={classes.cntrTable} >
            <h1 className={classes.cntrTxt}>{userData?.company?.name}</h1>
              <p className={classes.cntrTx122} style={{marginBottom: "40px"}} >
             Members' Monthly Deduction Summary Report - {reportMonth?.month}
              </p>
           

          </div>
 <table style={{ width: "100%", borderCollapse: "collapse", margin: 'auto' }}>
        <thead>
            <tr>
                <th
                    style={{
                        textAlign: "center",
                        fontSize: 12,
                        borderBottom: "1px solid #d1d5db"
                    }}
                >
                    S/N
                </th>
                <th
                    style={{
                        textAlign:"center",
                        fontSize: 12,
                        padding: 5,
                        borderBottom: "1px solid #d1d5db"
                        // whiteSpace: "nowrap"
                    }}
                >
                  MEMBER NAME
                </th>
                <th
                    style={{
                        textAlign:"center",
                        fontSize: 12,
                        padding: 5,
                        borderBottom: "1px solid #d1d5db"
                        // whiteSpace: "nowrap"
                    }}
                >
                  MEMBER NUMBER
                </th>
                <th
                    style={{
                        textAlign:"center",
                        fontSize: 12,
                        padding: 5,
                        borderBottom: "1px solid #d1d5db"
                        // whiteSpace: "nowrap"
                    }}
                >
                 DEPARTMENT
                </th>
                <th
                    style={{
                        textAlign:"center",
                        fontSize: 12,
                        padding: 5,
                        borderBottom: "1px solid #d1d5db"
                        // whiteSpace: "nowrap"
                    }}
                >
                 TOTAL SAVINGS
                </th>
                <th
                    style={{
                        textAlign:"center",
                        fontSize: 12,
                        padding: 5,
                        borderBottom: "1px solid #d1d5db"
                        // whiteSpace: "nowrap"
                    }}
                >
                  TOTAL LOAN
                </th>
                <th
                    style={{
                        textAlign:"center",
                        fontSize: 12,
                        padding: 5,
                        borderBottom: "1px solid #d1d5db"
                        // whiteSpace: "nowrap"
                    }}
                >
                  TOTAL DEDUCTION
                </th>
            </tr>
        </thead>
        <tbody>
            {reportRows.map((row, rowIndex) => (
                <tr key={rowIndex}>
                    <td
                        style={{
                            padding: 5,
                            fontSize: 13,
                            textAlign: "center"
                        }}
                    >
                        {rowIndex + 1}
                    </td>
                    <td style={{ padding: 5, fontSize: 13, borderBottom: "1px solid #d1d5db", textAlign: "left"}}>
                      {row.member_name}
                    </td>
                    <td style={{ padding: 5, fontSize: 13, borderBottom: "1px solid #d1d5db", textAlign: "left"}}>
                      {row.member_number}
                    </td>
                    <td style={{ padding: 5, fontSize: 13, borderBottom: "1px solid #d1d5db", textAlign: "left"}}>
                      --
                    </td>
                    <td style={{ padding: 5, fontSize: 13, borderBottom: "1px solid #d1d5db", textAlign: "right"}}>
                      {Number(row.total_savings).toLocaleString('en-NG', { minimumFractionDigits: 2 })}
                    </td>
                    <td style={{ padding: 5, fontSize: 13, borderBottom: "1px solid #d1d5db", textAlign: "right"}}>
                      {Number(row.total_loans).toLocaleString('en-NG', { minimumFractionDigits: 2 })}
                    </td>
                    <td style={{ padding: 5, fontSize: 13, borderBottom: "1px solid #d1d5db", textAlign: "right"}}>
                      {Number(row.total_deduction).toLocaleString('en-NG', { minimumFractionDigits: 2 })}
                    </td>
                </tr>
            ))}
        </tbody>


        </table>
        <div
  // style={{
  //   marginTop: 25,
  //   width: "40%",
  //   marginLeft: "auto",
  //   border: "1px solid #d1d5db",
  //   borderRadius: 6,
  //   overflow: "hidden",
  // }}
  className={classes.summaryContainer}
>
  <div
    style={{
      background: "#f5f5f5",
      padding: "10px 15px",
      fontWeight: "bold",
      fontSize: 14,
      borderBottom: "1px solid #d1d5db",
    }}
  >
    Summary:-
  </div>

  <div style={{ padding: 15 }}>
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        marginBottom: 10,
        fontSize: 13,
      }}
    >
      <span>Total Savings Deduction</span>
      <strong>
        {Number(reportMonth?.total_savings || 0).toLocaleString("en-NG", {
          minimumFractionDigits: 2,
        })}
      </strong>
    </div>

    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        marginBottom: 10,
        fontSize: 13,
      }}
    >
      <span>Total Loan Deduction</span>
      <strong>
        {Number(reportMonth?.total_loans || 0).toLocaleString("en-NG", {
          minimumFractionDigits: 2,
        })}
      </strong>
    </div>

    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        fontSize: 13,
        fontWeight: "bold",
        borderTop: "1px solid #d1d5db",
        paddingTop: 10,
      }}
    >
      <span>Total Deductions</span>
      <strong>
        {Number(reportMonth?.total_deductions || 0).toLocaleString("en-NG", {
          minimumFractionDigits: 2,
        })}
      </strong>
    </div>
  </div>
</div>
         </div> */}

          <div className={classes.body}>
      <div className={classes.payslip}>
        {/* Header */}
        <div className={classes.header}>
          <div className={classes.headerRow}>
            <div>
              <div className={classes.companyName}>{companyName}</div>
              <div className={classes.period}>
                COOPERATIVE DEDUCTION PAYSLIP
                <br />
                {period}
              </div>
            </div>
            <div>
              <h5 className={classes.payslipNo}>{payslipNo}</h5>
            </div>
          </div>
        </div>

        <div className={classes.content}>
          {/* Member Information */}
          <div className={classes.sectionTitle}>Member Information</div>

          <div className={classes.infoBox}>
            <div className={classes.infoRow}>
              <div>
                <strong>Membership No</strong>
                <br />
                0
              </div>
              <div>
                <strong>Name</strong>
                <br />
                {/* {member.name} */}
              </div>
              <div>
                <strong>Department</strong>
                <br />
                {/* {member.department} */}
              </div>
              <div>
                <strong>Payroll No</strong>
                <br />
                {/* {member.payrollNo} */}
              </div>
            </div>
          </div>

          {/* Summary */}
          {/* <div className={classes.summaryRow}>
            <div className={`${classes.summaryCard} ${classes.savings}`}>
              <h6>Savings</h6>
              <h3>{formatNaira(summary.savings)}</h3>
            </div>
            <div className={`${classes.summaryCard} ${classes.loan}`}>
              <h6>Loan Repayment</h6>
              <h3>{formatNaira(summary.loanRepayment)}</h3>
            </div>
            <div className={`${classes.summaryCard} ${classes.share}`}>
              <h6>Share Capital</h6>
              <h3>{formatNaira(summary.shareCapital)}</h3>
            </div>
            <div className={`${classes.summaryCard} ${classes.total}`}>
              <h6>Total Deduction</h6>
              <h3>{formatNaira(summary.totalDeduction)}</h3>
            </div>
          </div> */}

          {/* Deduction Breakdown */}
          <div className={classes.sectionTitle}>Deduction Breakdown</div>
          <table className={classes.table}>
            <thead>
              <tr>
                <th>Description</th>
                <th>Amount (₦)</th>
              </tr>
            </thead>
            <tbody>
              {deductions.map((item) => (
                <tr key={item.description}>
                  <td>{item.description}</td>
                  <td>{item.amount.toLocaleString('en-NG')}</td>
                </tr>
              ))}
            </tbody>
            <tfoot>
              <tr>
                <th>Total Deduction</th>
                <th>{totalDeductions.toLocaleString('en-NG')}</th>
              </tr>
            </tfoot>
          </table>

          {/* Loan Summary */}
          <div className={`${classes.sectionTitle} ${classes.mt4}`}>Loan Summary</div>
          <table className={classes.table}>
            <tbody>
              <tr>
                <th>Loan Product</th>
                <td>{loanSummary.loanProduct}</td>
              </tr>
              <tr>
                <th>Original Amount</th>
                <td>{formatNaira(loanSummary.originalAmount)}</td>
              </tr>
              <tr>
                <th>Outstanding Balance</th>
                <td>{formatNaira(loanSummary.outstandingBalance)}</td>
              </tr>
              <tr>
                <th>Next Installment</th>
                <td>{loanSummary.nextInstallment}</td>
              </tr>
            </tbody>
          </table>

          {/* Savings Summary */}
          <div className={`${classes.sectionTitle} ${classes.mt4}`}>Savings Summary</div>
          <table className={classes.table}>
            <tbody>
              <tr>
                <th>Current Savings Balance</th>
                <td>{formatNaira(savingsSummary.currentBalance)}</td>
              </tr>
              <tr>
                <th>Total Contributions</th>
                <td>{formatNaira(savingsSummary.totalContributions)}</td>
              </tr>
              <tr>
                <th>Last Contribution Date</th>
                <td>{savingsSummary.lastContributionDate}</td>
              </tr>
            </tbody>
          </table>
        </div>

        <div className={classes.footer}>
          Generated by Cooperative Management System
          <br />
          Printed on {printedOn}
        </div>
      </div>
    </div>

         


 </>
  {/* )} */}
 
        </div>
     <div style={{ marginTop: 27 }} />
 
      </div>
      {savingsLoading && (
                  <div className={classes.overlay}>
                    <img src={RotatingLogo} alt="Loading..." className={classes.spinnerLogo} />
                  </div>
                )}

    </div>
  )
}

export default MemeberPaySlipReport;